import Vue from "vue"
import { Component, Prop } from "vue-property-decorator"
import { NewContractEvents } from "../../new-contract-vue-events"

@Component({
})

export default class SessionExpiration extends Vue {

    @Prop()
    exceptionTitle: string;

    @Prop()
    okButtonText: string;

    @Prop()
    urlStartAgain: string;

    @Prop()
    urlMainPage: string;

    constructor() {
        super();
        console.log("SessionExpiration constructor()");
    }

    created() {
        console.log("SessionExpiration created()");
    }

    mounted() {
        NewContractEvents.addNotifySessionExpiredListener(this.sessionExpirationTriggered);
    }

    beforeDestroy() {
        NewContractEvents.removeNotifySessionExpiredListener(this.sessionExpirationTriggered);
    }

    sessionException: boolean = false;

    handleSessionException(show: boolean): void {
        console.log("handleSessionException()");
        this.sessionException = show;
    }

    // parameters:
    //   "cancel": go to main page
    //   "ok": start process again
    handleSessionExceptionClose(msg: string): void {
        console.log("handleSessionExceptionClose(): " + msg);
        $.blockUI({ message: "Ladataan..."});
        switch (msg) {
            case "ok": window.location.href = this.urlStartAgain; break;
            default: window.location.href = this.urlMainPage; break;
        }
    }

    sessionExpirationTriggered(): void {
        console.log("sessionExpirationTriggered()");
        if (!this.sessionException) {
            console.log("this.handleSessionException(true);");
            this.handleSessionException(true);
        }
    }

}